import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ progress, shimmer, timeRemaining, stopButton }) => {
  return (
    <div className="progress-bar-wrapper">
      <div className="progress-bar-container">
        <div className={`progress-bar ${shimmer ? 'shimmer' : ''}`} style={{ width: `${progress}%` }}></div>
      </div>
      {(!shimmer || timeRemaining || stopButton) && (
        <div className="progress-bar-meta">
          <div className="progress-bar-meta-left">
            {(!shimmer || timeRemaining) && (
              <>
                <span className="progress-bar-percent">{Math.round(progress || 0)}%</span>
                {timeRemaining && <span className="progress-bar-eta">{timeRemaining}</span>}
              </>
            )}
          </div>
          {stopButton}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
